module.exports = __webpack_public_path__ + "assets/img/2025.57cb2213.png";